import React, { useState } from "react";
import { Box } from "@mui/material";

import { makeStyles } from '@mui/styles';
import { alpha } from "@mui/material";
import { useTheme } from '@mui/material/styles';

const useStyles = makeStyles((theme) => {
  if (theme.palette) {
    return {
      fileInput: {
        color: theme.palette.primary.main,
        border: `1px solid ${alpha(theme.palette.primary.main, 0.5)}`,
        cursor: "pointer",
        fontWeight: 500,
        fontSize: "0.875em",
        padding: "5px 15px",
        borderRadius: "4px",
        '&:hover': {
          background: alpha(theme.palette.primary.main, 0.04),
          border: `1px solid ${theme.palette.primary.main}`,
        }
      },
    }
  }
  return {}
});

export default function FileUploadsDialog({ acceptedFileExtensions, fileInfo }) {
  const classes = useStyles();

  return (
    <form>
      <Box className="d-flex mt-2">
        <Box>
          <label htmlFor="file-upload" className={classes.fileInput}>
            Select File
          </label>
        </Box>
        <Box className="ms-2">
          {fileInfo?.file?.name}
        </Box>
        <input id="file-upload" type="file" accept={acceptedFileExtensions} onChange={e => fileInfo.setFile(e.target.files[0])} className="d-none" ref={ref => fileInfo.setFileInputRef(ref)} />
      </Box>
    </form>
  )
}